<template>
  <v-btn
    @click="downloadToCsv"
  >
    {{ $t('csv.exportCsv') }}
    <v-icon right>
      mdi-cloud-download
    </v-icon>
  </v-btn>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            default: 'table',
        },
        rowHeaders: {
            type: Array,
            default: null,
        },
        data: {
            type: Array,
            required: true,
        },
    },

    methods: {
        downloadToCsv() {
            this.$utils.exportAsCSV(this.data, this.rowHeaders);
        },
    },
};
</script>
